<div class="container-xl mt-5">
    <h1 class="text-start">Plataforma de Datos Abiertos</h1>
    <nav class="nav nav-pills flex-column flex-sm-row">
        <a class="flex-sm-fill text-sm-center nav-link" aria-current="page" href="#" style="width: 30%;">
            <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Sentencias</h5>
                  <p class="card-text">Contiene la información con las Sentencias emitidas por la Suprema Corte de Justicia de la Nación.</p>
                </div>
            </div>
        </a>
        <a class="flex-sm-fill text-sm-center nav-link" style="width: 30%;">
            <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Votos</h5>
                  <p class="card-text">Es la postura particular de uno o varios Ministros o Magistrados en relación de un asunto en concreto.</p>
                </div>
            </div>
        </a>
        <a class="flex-sm-fill text-sm-center nav-link" style="width: 30%;" [routerLink]="['/datos-abiertos/tesis']">
            <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Tesis</h5>
                  <p class="card-text">Es la expresión por escrito, en forma abstracta, de un criterio jurídico establecido al resolver un caso concreto.</p>
                </div>
            </div>
        </a>
    </nav>
</div>